module.exports = __webpack_public_path__ + "img/character_yema.9bd43998.png";